import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ValidationInfo } from '../../../../objectModel/validationInfo';

@Component({
    selector: 'app-field-validation-error-view',
    templateUrl: './field-validation-error-view.component.html',
    styleUrls: ['./field-validation-error-view.component.css'],
    standalone: false
})
export class FieldValidationErrorViewComponent implements OnInit {
  errorMessages: string[];

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: any) {
      this.errorMessages = data.errorMessages;
  }

  ngOnInit(): void {
  }

}
